import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavDropdown, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";

const TopNavigationSubMenu3 = ({ subMenuButtonTitle, subMenuId, subMenuItems }) => {

  const navigate = useNavigate();
  const [displaySubMenu, setDisplaySubMenu] = useState(false);
  const dropDownRef = useRef();

  const handleDirect = (path) => {
    if (path === "") {
      return;
    }
    setDisplaySubMenu(false);
    navigate(path);
  }

  const handleMouseOver = () => {
    setDisplaySubMenu(true);
  }

  const handleMouseLeave = () => {
    setTimeout(() => {
      setDisplaySubMenu(false);
    }, 300);
  }

  const handleOnKeyDown = (e, link) => {
    //console.log("handleOnKeyDown", e);
    // Key "Down Arrow" to open the dropdown
    if (e.keyCode === 40) {
      if (!displaySubMenu) {
        setDisplaySubMenu(true);
      }
    }

    // Key "Up Arrow" to close the dropdown
    if (e.keyCode === 38) {
      if (displaySubMenu) {
        setDisplaySubMenu(false);
      }
    }

    // Key "Enter" to direct
    if (e.keyCode === 13) {
      if (link) {
        handleDirect(link);
      }
    }
  }

  const handleOnBlur = (e, col1, index) => {
    //console.log("handleOnBlur", e, col1, index, subMenuItems);
    // two columns of submenu
    if (subMenuItems.col2.length && subMenuItems.col2.length > 0) {
      if (!col1 && (index + 1 == subMenuItems.col2.length)) {
        setDisplaySubMenu(false);
      }
    } else {
      // one columns of submenu
      if (col1 && (index + 1 == subMenuItems.col1.length)) {
        setDisplaySubMenu(false);
      }
    }
  }

  return (
    <>
      <NavDropdown
        title={
          <Stack direction="horizontal" gap={2}>
            <div className="text-wrap body semibold lh-1">{subMenuButtonTitle}</div>
            <div>{displaySubMenu ?
              <FontAwesomeIcon className="profileMenuIcon" icon={faChevronUp} />
              :
              <FontAwesomeIcon className="profileMenuIcon" icon={faChevronDown} />}
            </div>
          </Stack>
        }
        //renderMenuOnMount={false}
        className="topNavSubMenu"
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        onKeyDown={(e) => handleOnKeyDown(e, "")}
        show={displaySubMenu}
        ref={dropDownRef}
      >
        <Stack direction="horizontal" gap={2} style={{ alignItems: "normal" }}>
          <div className="p-2" style={subMenuItems.col2.length === 0 ? { width: "100%" } : { width: "50%" }}>
            {subMenuItems.col1.map((item, index) => (
              <>
                {/* <Stack tabIndex={0} direction="horizontal" gap={2} onClick={() => handleDirect(item.link)} onKeyDown={(e) => handleSubMenuKeyDown(e, item.link)}> */}
                <Stack as={Link} to={item.link} direction="horizontal" gap={2} className="topNavSubMenuItem p-0"
                  //onClick={() => handleDirect(item.link)}
                  //onKeyDown={(e) => handleOnKeyDown(e, item.link)}
                  //onBlur={(e) => handleOnBlur(e, true, index)}
                >
                  <div className="topNavSubMenuItemIcon">{item.icon()}</div>
                  <div className="topNavSubMenuItemText">
                    <div className="title">{item.title}</div>
                    <div className="desc">{item.desc}</div>
                  </div>
                </Stack>
              </>
            ))}
          </div>
          {subMenuItems.col2.length === 0 ? null :
            <div className="vr m-1" />
          }
          <div className="p-2" style={{ width: "50%" }}>
            {subMenuItems.col2.map((item, index) => (
              <>
                <Stack as={Link} to={item.link} direction="horizontal" gap={2} className="topNavSubMenuItem p-0"
                  //onClick={() => handleDirect(item.link)}
                  //onKeyDown={(e) => handleOnKeyDown(e, item.link)}
                  //onBlur={(e) => handleOnBlur(e, false, index)}
                >
                  <div className="topNavSubMenuItemIcon">{item.icon()}</div>
                  <div className="topNavSubMenuItemText">
                    <div className="title">{item.title}</div>
                    <div className="desc">{item.desc}</div>
                  </div>
                </Stack >
              </>
            ))}
          </div>
        </Stack>
      </NavDropdown >
    </>
  )
}

export default TopNavigationSubMenu3;